import classNames from 'classnames';
import React from 'react';
import { Button } from 'shared';
import { hasError } from 'utils';

import { EnvSelectOptions, EnvSelectWrapper, ErrorMessage } from './EnvSelect.styles';
import { EnvSelectProps } from './EnvSelect.types';

export const EnvSelect = ({ options, meta, input }: EnvSelectProps) => {
  const isError = hasError(meta, false);
  const handleClick = (option: any) => input.onChange(option);

  return (
    <EnvSelectWrapper className={classNames('env-select', isError && 'env-select--error')}>
      <EnvSelectOptions className="env-select__options">
        {options.map(option => (
          <Button
            key={option}
            htmlType="button"
            type={'select'}
            className={input.value === option ? 'selected' : 'unselected'}
            onClick={handleClick.bind(undefined, option)}
          >
            {option}
          </Button>
        ))}
      </EnvSelectOptions>
      {isError && <ErrorMessage className="env-select__error">{meta.error || meta.submitError}</ErrorMessage>}
    </EnvSelectWrapper>
  );
};
